var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-4 align-center ml-4",on:{"click":function($event){return _vm.$emit('to')}}},[_c(_setup.Icon,{key:_setup.type,staticClass:"custom-icon",attrs:{"name":_setup.iconName,"type":_setup.type,"size":"33","color":_setup.color}}),_c('h3',{staticClass:"ml-4 font-size-14",class:{
      'font-grey': !_setup.isActiveOrChecked,
      'font-weight-500': !_setup.isActiveOrChecked,
    },style:({ color: _setup.textColor })},[_vm._v(" "+_vm._s(_setup.props.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }